module.exports = __webpack_public_path__ + "static/assets/a8bd727cbe1bac5cc927fdccfb13cbf7.svg";